import React from 'react';
import { Link } from "react-router-dom";
import styled from "styled-components";

const SGrammarCondicionales = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarCondicionales = () => {
  return (
    <SGrammarCondicionales>
<h5>Frases condicionales - Zdania warunkowe</h5>

<p>Zdania wyrażające warunek mają dwie części, z których pierwsza przedstawia warunek (zawiera słowo "jeśli"), a druga jest zdaniem
 nadrzędnym. W tzw. pierwszym zdaniu warunkowym część podrzędna jest wyrażona w czasie teraźniejszym
 (<i><Link to="/grammar/indicativo#pre">Presente</Link></i>), a część nadrzędna w czasie przyszłym
 (<i><Link to="/grammar/indicativo#fim">Futuro</Link></i>) lub rzadziej w trybie rozkazującym
 (<i><Link to="/grammar/imperativo">Imperativo</Link></i>) czy czasie teraźniejszym
 (<i><Link to="/grammar/indicativo#pre">Presente</Link></i>). Takie zdanie wyraża warunek realny, możliwy do spełnienia:
</p>
<p>
<i>Si <b>hace</b> buen tiempo, <b>iremos</b> a la playa</i> - Jeśli będzie ładna pogoda, pójdziemy na plażę.<br/>
<i>Si me <b>necesitas</b>, <b>llámame</b></i> - Jeśli będziesz mnie potrzebować, zadzwoń do mnie.<br/>
<i>Si <b>podemos</b>, <b>salimos</b> todas las noches</i> - Jeśli możemy, wychodzimy w każdy wieczór.
</p>
<p>Drugie zdanie warunkowe wyraża warunek nierealny lub mało prawdopodobny i składa się z części podrzędnej (zawierającej słowo "jeśli")
  w czasie <i><Link to="/grammar/subjuntivo">Imperfecto de Subjuntivo</Link></i> oraz z trybu przypuszczającego
  (<i><Link to="/grammar/condicional">Condicional</Link></i>) w części nadrzędnej:
</p>
<p>
<i>Si <b>tuviera</b> tiempo, <b>haría</b> algun deporte</i> - Gdybym miał czas, uprawiałbym jakiś sport.
</p>
<p>Istnieje też trzecie zdanie warunkowe oraz zdania tzw. mieszane, ale ze względu na małe użycie tych form pozwalamy sobie na razie tylko na małą
 o nich wzmiankę.</p>
    </SGrammarCondicionales>
  )
};

export default GrammarCondicionales;